import React from 'react';
import PropTypes from 'prop-types';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const MembershipSuccess = ({ membership, membershipProduct, venueOwnership, pendingGift = null }) => {
  const subtotal = membership.amount_cents / 100;
  const absorb_fees = membership.absorb_fees;
  const totalFees = absorb_fees ? 0 : (membership.total_fee_amount_cents || 0) / 100;
  const totalTax = (membership.total_tax_amount_cents || 0) / 100;
  const total = membership.customer_pays;

  return (
    <div>
      <div className="row position-fixed" style={{ bottom: "0px", left: "15px", width: "100%", zIndex: 1000 }}>
        <div className="col-12" style={{ padding: "15px" }}>
          <p className="mb-0" style={{ fontSize: "14px", color: "#686868" }}>
            Powered by
            <a href="https://www.opendate.io/" target="_blank" rel="noopener noreferrer">
              <img className="ml-2" style={{ width: "88px" }} src="/opendate_logo.png" alt="Opendate" />
            </a>
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <p className="text-dark" style={{ fontSize: "24px", marginBottom: "38px" }}>
            <strong>{pendingGift ? (pendingGift.sendsOn ? 'Gift scheduled' : 'Gift sent') : 'Confirmed'}</strong>
          </p>
          <p className="mb-0 text-dark" style={{ fontSize: "40px" }}>
            <strong>Thank you, {membership.first_name}!</strong>
          </p>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12 col-md-6 col-lg-8 mb-5">
          {pendingGift && (
            <div data-testid="gift-sent">
              <p className="mb-3 text-dark" style={{ fontSize: "32px", overflowWrap: "anywhere" }}>
                <strong>
                  {pendingGift.sendsOn ? `Your gift email sends ${pendingGift.sendsOn} to ${pendingGift.firstName} ${pendingGift.lastName}`.trim() : `Your gift is on its way to ${pendingGift.firstName} ${pendingGift.lastName}`.trim()} at{' '}
                  <a href={`mailto:${pendingGift.email}`} style={{ color: "#1982C4" }}>
                    {pendingGift.email}
                  </a>
                </strong>
              </p>
              <p className="mb-3 text-dark" style={{ fontSize: "18px" }}>
                {pendingGift.firstName} has until {pendingGift.acceptBy} to claim it. Their membership starts when they claim.
              </p>
              <p className="mb-3 text-dark" style={{ fontSize: "18px" }}>
                {pendingGift.renewsAt
                  ? `After ${pendingGift.firstName}'s first ${pendingGift.renewalInterval === 'month' ? 'month' : 'year'}, it renews at ${pendingGift.renewsAt}/${pendingGift.renewalInterval === 'month' ? 'month' : 'year'} on your card. Turn it off anytime from your account.`
                  : "This membership won't renew, so you won't be charged again."}
              </p>
              <p className="mb-3 text-dark" style={{ fontSize: "18px" }}>
                If {pendingGift.firstName} doesn't claim it by {pendingGift.acceptBy}, we'll refund you in full.
              </p>
              <p className="mb-3 text-dark" style={{ fontSize: "18px" }}>
                Your receipt has been sent to {membership.email}.
              </p>
            </div>
          )}
          {!pendingGift && (
            <p className="mb-3 text-dark" style={{ fontSize: "32px", overflowWrap: "anywhere" }}>
              <strong>
                A confirmation receipt has been sent to{' '}
                <a href={`mailto:${membership.email}`} style={{ color: "#1982C4" }}>
                  {membership.email}
                </a>
              </strong>
            </p>
          )}
          <p className="mb-3 text-dark" style={{ fontSize: "18px" }}>
            Transaction <a href="#" target="_blank" rel="noopener noreferrer">#{membership.id}</a>
          </p>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-5">
          {membershipProduct.image_url && (
            <img className="img-fluid rounded" src={membershipProduct.image_url} alt={membershipProduct.name} />
          )}

          <div className="row">
            <div className="col-12">
              <p style={{ fontSize: "18px", marginTop: "20px", marginBottom: "15px" }}>
                <strong>Order Confirmation</strong>
              </p>

              <div className="row" style={{ marginBottom: "12px" }}>
                <div className="col">
                  <p className="mb-0" style={{ fontSize: "16px" }}>
                    1 x {membershipProduct.name}
                  </p>
                </div>
                <div className="col-xs-auto text-right" style={{ paddingRight: "15px" }}>
                  <p className="mb-0" style={{ fontSize: "16px" }}>
                    {subtotal === 0 ? 'FREE' : formatter.format(subtotal)}
                  </p>
                </div>
              </div>

              <hr style={{ borderTop: "1px solid #ececec" }} />

              <div className="row" style={{ marginBottom: "12px" }}>
                <div className="col">
                  <p className="mb-0" style={{ fontSize: "16px" }}>
                    Subtotal
                  </p>
                </div>
                <div className="col-xs-auto text-right" style={{ paddingRight: "15px" }}>
                  <p className="mb-0" style={{ fontSize: "16px" }}>
                    {formatter.format(subtotal)}
                  </p>
                </div>
              </div>

              {!absorb_fees && (
                <div className="row" style={{ marginBottom: "12px" }}>
                  <div className="col">
                    <p className="mb-0" style={{ fontSize: "16px" }}>
                      Fees
                    </p>
                  </div>
                  <div className="col-xs-auto text-right" style={{ paddingRight: "15px" }}>
                    <p className="mb-0" style={{ fontSize: "16px" }}>
                      {formatter.format(totalFees)}
                    </p>
                  </div>
                </div>
              )}

              {totalTax > 0 && (
                <div className="row" style={{ marginBottom: "12px" }}>
                  <div className="col">
                    <p className="mb-0" style={{ fontSize: "16px" }}>
                      Tax
                    </p>
                  </div>
                  <div className="col-xs-auto text-right" style={{ paddingRight: "15px" }}>
                    <p className="mb-0" style={{ fontSize: "16px" }}>
                      {formatter.format(totalTax)}
                    </p>
                  </div>
                </div>
              )}

              <hr style={{ borderTop: "1px solid #ececec" }} />

              <div className="row" style={{ marginBottom: "12px" }}>
                <div className="col">
                  <p className="mb-0" style={{ fontSize: "16px" }}>
                    <strong>Total</strong>
                  </p>
                </div>
                <div className="col-xs-auto text-right" style={{ paddingRight: "15px" }}>
                  <p className="mb-0" style={{ fontSize: "16px" }}>
                    <strong>{formatter.format(total)}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MembershipSuccess.propTypes = {
  membership: PropTypes.shape({
    id: PropTypes.number.isRequired,
    first_name: PropTypes.string,
    email: PropTypes.string.isRequired,
    absorb_fees: PropTypes.bool.isRequired,
    amount_cents: PropTypes.number.isRequired,
    total_fee_amount_cents: PropTypes.number.isRequired,
    total_tax_amount_cents: PropTypes.number.isRequired,
    customer_pays: PropTypes.number.isRequired,
  }).isRequired,
  membershipProduct: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image_url: PropTypes.string
  }).isRequired,
  venueOwnership: PropTypes.object,
  pendingGift: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    acceptBy: PropTypes.string.isRequired,
    sendsOn: PropTypes.string,
    renewsAt: PropTypes.string,
    renewalInterval: PropTypes.oneOf(['month', 'year'])
  })
};

MembershipSuccess.defaultProps = {
  pendingGift: null
};

export default MembershipSuccess;
